import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Solid - General
import { faCircleExclamation as fasCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faEye as fasEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faMagnifyingGlass as fasMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faGrid as fasGrid } from '@fortawesome/pro-solid-svg-icons/faGrid';
import { faUserPlus as fasUserPlus } from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import { faPen as fasPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faHexagon as fasHexagon } from '@fortawesome/pro-solid-svg-icons/faHexagon';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faSquare as fasSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faEllipsisVertical as fasEllipsisVertical } from '@fortawesome/pro-solid-svg-icons/faEllipsisVertical';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faCaretRight as fasCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faCircleQuestion as fasCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCog as fasCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faCircleInfo as fasCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faArrowLeft as fasArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight as fasArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faCircleXmark as fasCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faBarsSort as fasBarsSort } from '@fortawesome/pro-solid-svg-icons/faBarsSort';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faEyeSlash as fasEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faFloppyDisk as fasFloppyDisk } from '@fortawesome/pro-solid-svg-icons/faFloppyDisk';
import { faLocationDot as faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';

// Regular
import { faBell as farBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faMagnifyingGlass as farMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faArrowLeft as farArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faChevronLeft as farChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faXmark as farXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faLink as farLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faCircleXmark as farCircleXmark } from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import { faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faImage as farImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faChevronRight as farChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronDoubleRight as farChevronDoubleRight } from '@fortawesome/pro-regular-svg-icons/faChevronDoubleRight';
import { faChevronDoubleLeft as farChevronDoubleLeft } from '@fortawesome/pro-regular-svg-icons/faChevronDoubleLeft';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faInfoCircle as farInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faExclamationCircle as farExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import { faFilter as farFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';

// Light
import { faBell as falBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faUserPlus as falUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faEye as falEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faEarthAfrica as falEarthAfrica } from '@fortawesome/pro-light-svg-icons/faEarthAfrica';

// Duo-tone
import { faSort as fadSort } from '@fortawesome/pro-duotone-svg-icons/faSort';
import { faChartNetwork as fadChartNetwork } from '@fortawesome/pro-duotone-svg-icons/faChartNetwork';
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import { faEarthAfrica as fadEarthAfrica } from '@fortawesome/pro-duotone-svg-icons/faEarthAfrica';
import { faCamera as fadCamera } from '@fortawesome/pro-duotone-svg-icons/faCamera';
import { faBullhorn as fadBullhorn } from '@fortawesome/pro-duotone-svg-icons/faBullhorn';
import { faFloppyDisk as fadFloppyDisk } from '@fortawesome/pro-duotone-svg-icons/faFloppyDisk';

// SHARP Solid
import { faHexagon as fassHexagon } from '@fortawesome/sharp-solid-svg-icons/faHexagon';
import { faSquare as fassSquare } from '@fortawesome/sharp-solid-svg-icons/faSquare';
import { faCaretDown as fassCaretDown } from '@fortawesome/sharp-solid-svg-icons/faCaretDown';
import { faCaretRight as fassCaretRight } from '@fortawesome/sharp-solid-svg-icons/faCaretRight';
import { faCaretLeft as fassCaretLeft } from '@fortawesome/sharp-solid-svg-icons/faCaretLeft';
import { faFloppyDisk as fassFloppyDisk } from '@fortawesome/sharp-solid-svg-icons/faFloppyDisk';
import { faArrowUpRightFromSquare as fassArrowUpRightFromSquare } from '@fortawesome/sharp-solid-svg-icons/faArrowUpRightFromSquare';

// SHARP Duotone Solid
import { faChartNetwork as fadsChartNetwork } from '@fortawesome/sharp-duotone-solid-svg-icons/faChartNetwork';
import { faFloppyDisk as fadsFloppyDisk } from '@fortawesome/sharp-duotone-solid-svg-icons/faFloppyDisk';

// Add icons to the library
library.add(
  // Solid
  fasCircleExclamation,
  fasEye,
  fasMagnifyingGlass,
  fasList,
  fasGrid,
  fasUserPlus,
  fasPen,
  fasUser,
  fasHexagon,
  fasCircle,
  fasSquare,
  fasEllipsisVertical,
  fasCaretDown,
  fasGlobe,
  fasCaretRight,
  fasCircleQuestion,
  fasBullhorn,
  fasCog,
  fasCircleInfo,
  fasChevronLeft,
  fasArrowLeft,
  fasArrowRight,
  fasChevronDown,
  fasChevronUp,
  fasCircleXmark,
  fasBarsSort,
  fasChevronRight,
  fasEyeSlash,
  fasBars,
  fasFloppyDisk,
  faLocationDot,

  // Regular
  farBell,
  farMagnifyingGlass,
  farPlus,
  farArrowLeft,
  farXmark,
  farChevronLeft,
  farLink,
  farCircleXmark,
  farChevronDown,
  farImage,
  farChevronRight,
  farChevronDoubleRight,
  farChevronDoubleLeft,
  farCheckCircle,
  farInfoCircle,
  farExclamationCircle,
  farFilter,

  // Light
  falBell,
  falUserPlus,
  falEye,
  falEarthAfrica,

  // Duo-tone
  fadSort,
  fadChartNetwork,
  fadSpinnerThird,
  fadEarthAfrica,
  fadCamera,
  fadBullhorn,
  fadFloppyDisk,

  // Sharp Solid
  fassHexagon,
  fassSquare,
  fassCaretDown,
  fassCaretRight,
  fassFloppyDisk,
  fassArrowUpRightFromSquare,
  fassCaretLeft,

  // Sharp Duotone Solid
  fadsChartNetwork,
  fadsFloppyDisk,
);

// Watch the DOM and replace any <i> tags with SVG icons
dom.watch();
